import { render, staticRenderFns } from "./Borussia-17-18-Home.vue?vue&type=template&id=b600f8b8&"
import script from "./Borussia-17-18-Home.vue?vue&type=script&lang=js&"
export * from "./Borussia-17-18-Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports